export default __webpack_public_path__ + "static/media/WhatsApp.fd95dd24.svg";